import { render, staticRenderFns } from "./paymentAdaptList.vue?vue&type=template&id=3f478dc6&scoped=true"
import script from "./paymentAdaptList.vue?vue&type=script&lang=js"
export * from "./paymentAdaptList.vue?vue&type=script&lang=js"
import style0 from "./paymentAdaptList.vue?vue&type=style&index=0&id=3f478dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f478dc6",
  null
  
)

export default component.exports